import { SubCategory } from "types/subCategory";

export class Category {
    static readonly ASSISTANCE = new Category("ASSISTANCE", [
        SubCategory.ADMINISTRATIVE,
        SubCategory.TROUBLESHOOTING,
        SubCategory.INTERNET_USE,
        /*SubCategory.JOB_SEARCHING,*/
    ]);
    static readonly HANDIWORK = new Category("HANDIWORK", [
        SubCategory.SIMPLE,
        SubCategory.SMALL_REPAIR,
        SubCategory.INSTALLATION,
    ]);
    static readonly HOUSEKEEPING = new Category("HOUSEKEEPING", [
        SubCategory.CLEANING,
        //SubCategory.IRONING,
        SubCategory.LAUNDRY,
    ]);
    static readonly CHILDCARE = new Category("CHILDCARE", [
        SubCategory.BABYSITTING_DURING_WEEK,
        SubCategory.BABYSITTING_DURING_WEEKEND,
    ]);
    static readonly GARDENING = new Category("GARDENING", [
        SubCategory.PLANTATION,
        SubCategory.TERRACE,
        SubCategory.TRIMMING,
        SubCategory.OUTDOOR_CLEANING,
    ]);
    static readonly PRIVATE_TUTORING = new Category("PRIVATE_TUTORING", [
        SubCategory.HOMEWORK,
        SubCategory.FOREIGN_LANGUAGES,
        SubCategory.OTHER_LESSON,
    ]);

    private constructor(public readonly key: string, public readonly values: Array<string>) {}

    toString() {
        return this.key;
    }
}
